import React from 'react';

export default class UmpireRequestStatusTransformer {
    transform(value) {

        if (typeof value === 'object') {
            if (!value.hasOwnProperty('value')) {
                console.error('UmpireRequestStatusTransformer: value is object, but does not have "value" property.');
                return '';
            }
            value = value.value;
        }

        let definedColor = null;
        let text = null;
        switch (value) {
            case 'ACCEPTED':
                definedColor = 'green';
                text = 'Akzeptiert (Accepted)';
                break;
            case 'REQUESTED':
                definedColor = 'gold';
                text = 'Angefordert (Requested)';
                break;
            case 'DECLINED':
                definedColor = 'orange';
                text = 'Abgelehnt (Declined)';
                break;
        }

        return (
            <div style={{color: definedColor}}>
                {text}
            </div>
        );
    }
}
